// All types of surveys
export enum SurveyTypes {
    SELF_KNOWLEDGE = 'osobnostny-dotaznik',
    HELP_SLOVAKIA = 'chut-pomoct-slovensku',
    HELP_FROM_GROWNI = 'pomohlo-ti-growni-dotaznik',
    RESILIENCE = 'dotaznik-odolnosti',
    BIG_FIVE = 'dotaznik-velkej-patky',
    KOHLBERG = 'moralny-vyvoj',
    KEGAN = 'dospely-vyvoj',
    HOLLAND = 'karierne-zaujmy',
    SCHWARTZ = 'hodnoty',
    GROWTH_MINDSET = 'rastove-myslenie',
    ATTACHMENT = 'vztahove-styly',
    SDT = 'motivacia',
    VIA = 'charakterove-silne-stranky',
    EXCELLENCE = 'index-excelencie',
    ENTREPRENEURSHIP = 'podnikavost-a-angažovanost',
    LEADERSHIP_STYLES = 'styly-vedenia',
    LALOUX_PARADIGMS = 'organizacne-paradigmy',
    KEGAN_ORDERS = 'urovne-vedomia',
    LISTENING_LEVELS = 'urovne-pocuvania'
}

export const SurveyTitle = {
    [SurveyTypes.SELF_KNOWLEDGE]: 'Osobnostný dotazník',
    [SurveyTypes.HELP_SLOVAKIA]: 'Chuť pomôcť Slovensku',
    [SurveyTypes.HELP_FROM_GROWNI]: 'Pomohlo ti GROWNi?',
    [SurveyTypes.RESILIENCE]: 'Dotazník odolnosti',
    [SurveyTypes.BIG_FIVE]: 'Dotazník Veľkej päťky (Big 5)',
    [SurveyTypes.KOHLBERG]: 'Morálny vývoj (Kohlberg)',
    [SurveyTypes.KEGAN]: 'Dospelý vývoj (Kegan)',
    [SurveyTypes.HOLLAND]: 'Kariérne záujmy (Holland)',
    [SurveyTypes.SCHWARTZ]: 'Hodnoty (Schwartz)',
    [SurveyTypes.GROWTH_MINDSET]: 'Rastové myslenie (Dweck)',
    [SurveyTypes.ATTACHMENT]: 'Vzťahové štýly',
    [SurveyTypes.SDT]: 'Motivácia (SDT)',
    [SurveyTypes.VIA]: 'Charakterové silné stránky (VIA)',
    [SurveyTypes.EXCELLENCE]: 'Index excelencie',
    [SurveyTypes.ENTREPRENEURSHIP]: 'Podnikavosť a občianska angažovanosť',
    [SurveyTypes.LEADERSHIP_STYLES]: 'Štýly vedenia (Goleman)',
    [SurveyTypes.LALOUX_PARADIGMS]: 'Organizačná kultúra (Laloux)',
    [SurveyTypes.KEGAN_ORDERS]: 'Úrovne vedomia (Kegan)',
    [SurveyTypes.LISTENING_LEVELS]: 'Úrovne počúvania (CTI)'
}
